import { Aggregate } from "./Aggregate";
import { Amount } from "./Amount";
import { PaymentMethod } from "./PaymentMethod";

export interface PaymentStatusResponse {
  aggregate: Aggregate;
  amount: Amount;
  state: VippsStatusType;
  paymentMethod: PaymentMethod;
  profile: string;
  pspReference: string;
  reference: string;
}

export enum VippsStatusType {
  created = "created",
  authorized = "authorized",
  aborted = "aborted",
  expired = "expired",
  cancelled = "cancelled",
  captured = "captured",
  refunded = "refunded",
  terminated = "terminated",
  error = "error",
}
